import PropTypes from 'prop-types'
import React from 'react'
import Select, { Creatable } from 'react-select-plus'
import classNames from 'classnames'
require('react-select-plus/dist/react-select-plus.css')
import style from './style.styl'

const UISelect = ({
  value,
  options,
  onSelection,
  className,
  arrow = true,
  SelectComponent = Select,
  onInputChange,
  clearable = false,
  ...props
}) => (
  <SelectComponent
    value={value}
    options={options}
    onChange={onSelection}
    clearable={clearable}
    className={classNames(style.UISelect, 'UISelect', className, { 'arrow-disabled': !arrow })}
    onInputChange={onInputChange}
    {...props}
  />
)

UISelect.propTypes = {
  arrow: PropTypes.bool,
}

const CreatableUISelect = props => <UISelect {...props} SelectComponent={Creatable} />

export { CreatableUISelect as Creatable }

export default UISelect



// WEBPACK FOOTER //
// ./src/scripts/components/shared/UISelect/index.js